import { Component, Input } from '@angular/core';
import { PanelState } from '../../../beans/dashboard/dashboard-module.bean';
import { MessagingService } from '../../../services/messaging/messaging.service';
import { AnalyticsBean } from 'src/app/beans/analytics/analytics-module.bean';
import { USER_LEVEL } from '../../../constants/user.level.constants';
import { Environment } from '../../../config/environment';
import { APP_USER_PERMISSIONS } from 'src/app/constants/app-user-permissions.constants';

/**
 * Welcome panel component
 */
@Component({
	selector: 'app-welcome-panel',
	templateUrl: './welcome-panel.component.html',
	styleUrls: ['./welcome-panel.component.scss'],
})
export class WelcomePanelComponent {
	/** to check if member is matched */
	@Input() isMatchedMember: boolean;
	/** holds dashboard state object */
	@Input() panelStatus: PanelState;
	/** holds analytics object */
	analyticsData: AnalyticsBean;
	/** Holds user_level enum object */
	USER_LEVEL = USER_LEVEL;
	MODULE_LEVEL = APP_USER_PERMISSIONS;

	// TODO: Declared but not used
	state: any;

	// TODO: Declared but not used
	upcomingAppts: any;

	// TODO: Declared but not used
	slideIndex: any;

	/**
	 * Welcome panel constructor
	 * @param dataCarrier - data carrier service
	 * @param messagingService - messaging service
	 * @param environment - holds environment variables
	 */
	constructor(
		public messagingService: MessagingService,
		public environment: Environment
	) {
		this.analyticsData = new AnalyticsBean();
		this.analyticsData.componentName = 'welcome-panel';
		this.analyticsData.pageUrl = '/dashboard';
	}

	// TODO: Declared but not used
	currentSlide(i: number) {}
}
